import { motion } from 'framer-motion';
import { Box, Typography, Container, Link, Grid, Stack } from '@mui/material';
import mindtoart from '../assets/logoVertical.svg';
import { useRecoilState, useSetRecoilState, useRecoilValue } from 'recoil';

import { bgState } from '../state';
import { Download } from '../components/Download';
import { ExpertCards } from '../components/ExpertCards';
import { FAQ } from '../components/FAQ';

import longScreen from '../assets/longscreen2.png';

export function Landing() {
  const setBG = useSetRecoilState(bgState);

  return (
    <Box
      sx={{
        position: 'relative',
        display: 'flex',
        flexDirection: 'column',
        alignContent: 'center',
        justifyContent: 'center',
        flexGrow: 1,
        mb: '6vh'
      }}>
      <Container sx={{
        mt: '6vh',
        flexGrow: 1,
      }}>
        <Grid
          container
          spacing={1}
          justifyContent={'space-evenly'}>

          <Grid item xs={12} sm={7}>
            <Stack
              direction="column"
              alignItems={'flex-start'}
              sx={{
                color: 'text.primary',
              }}>
              <Typography
                variant="h3"
                mb={4}
                textAlign={'left'}
                fontWeight={'bold'}>
                Chat Your Ideas into Art
              </Typography>
              <Typography
                variant="h6"
                mb={1}
                textAlign={'left'}>
                Forget subscriptions. With our transparent pay-as-you-go tokens, you only pay for the visuals you create. Experience limitless image generation and bring your most ambitious concepts to life, all through chat.
              </Typography>
              <Typography
                variant="h6"
                mb={1}
                textAlign={'left'}>
                Collaborate with a creative AI partner. Describe your vision, refine details through conversation, and watch as your words are translated into stunning, unique artwork. It's a seamless dialogue between your imagination and our AI.
              </Typography>
              <Typography
                variant="h6"
                mb={1}
                textAlign={'left'}>
                Design characters for your stories, visualize fantastical worlds, or craft abstract masterpieces. Your creativity is the only boundary. Foster a unique artistic process where you are the director and the AI is your brush.
              </Typography>
              <Typography
                variant="h6"
                mb={1}
                textAlign={'left'}>
                From concept art for projects to unique graphics for social media, our AI is your dedicated visual assistant. Get the perfect image you need, whenever you need it, just by describing it.
              </Typography>

              <Box sx={{ width: '100%', mt: '3vh' }}>
                <Download />
              </Box>
            </Stack>
          </Grid>

          <Grid item xs={12} sm={5} sx={{
            display: { xs: 'none', sm: 'flex' },
            justifyContent: 'center',
          }}>
            <Box
              sx={{
                // height: { xs: '12vmin', sm: '8vmin', md: '6vmin', xl: '6vmin' },
                maxWidth: { xs: '12vmin', sm: '90%', md: '60%', xl: '50%' },
                // height: 'auto',
                borderRadius: '20px',
                aspectRatio: '9/20',
              }}
            >
              <img
                src={longScreen}
                style={{ height: '100%', width: 'auto', borderRadius: '20px' }}
                alt='App Screen'
              />
            </Box>
          </Grid>
        </Grid>
      </Container>

      <Box sx={{
        flexGrow: 1,
        position: 'relative',
        display: 'flex',
        alignContent: 'center',
        justifyContent: 'center',
        flexDirection: 'column',
        width: '100%',
        mt: '6vh',
      }}>
        <ExpertCards />
      </Box>

      <Container sx={{
        mt: '6vh',
        flexGrow: 1,
      }}>
        <FAQ />
      </Container>
    </Box >
  );
}

export default Landing;
